import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M677.647 16v338.936h112.941V129.054h1016.47V919.53h-225.994v259.765L1321.412 919.53h-79.172V467.878H0v1016.47h338.71v418.9l417.996-418.9h485.534v-451.877h32.753l419.125 419.124v-419.124H1920V16H677.647zM338.79 919.563h564.706v-112.94H338.79v112.94zm0 225.883h338.936v-113.054H338.79v113.054zM112.94 580.706h1016.47v790.701H710.4L451.652 1631.06v-259.652h-338.71V580.706z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconDiscussionLine = /*#__PURE__*/function (_Component) {
  _inherits(IconDiscussionLine, _Component);

  var _super = _createSuper(IconDiscussionLine);

  function IconDiscussionLine() {
    _classCallCheck(this, IconDiscussionLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconDiscussionLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconDiscussion",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconDiscussionLine.displayName = "IconDiscussionLine";
  return IconDiscussionLine;
}(Component);

IconDiscussionLine.glyphName = 'discussion';
IconDiscussionLine.variant = 'Line';
IconDiscussionLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconDiscussionLine;
export { IconDiscussionLine };